import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../contexts/AuthContext';

function ProcessedContent() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { hash } = useParams();
  const { currentUser } = useAuth();

  useEffect(() => {
    async function fetchContent() {
      if (!hash) return;

      try {
        console.log('Fetching content for hash:', hash);
        
        // First try to find public content
        let q = query(
          collection(db, 'contents'),
          where('processedPath', '==', `${hash}/index.html`),
          where('isPublic', '==', true)
        );
        
        let querySnapshot = await getDocs(q);
        
        // If no public content found and user is authenticated, try to find private content
        if (querySnapshot.empty && currentUser) {
          q = query(
            collection(db, 'contents'),
            where('processedPath', '==', `${hash}/index.html`),
            where('userId', '==', currentUser.uid)
          );
          querySnapshot = await getDocs(q);
        }

        if (!querySnapshot.empty) {
          const doc = querySnapshot.docs[0];
          const contentData = doc.data();
          console.log('Found content:', contentData);
          setContent(contentData);
        } else {
          console.log('No content found for hash:', hash);
          setError('Content not found or you do not have permission to view it.');
        }
      } catch (error) {
        console.error('Error fetching content:', error);
        setError('Error loading content. Please try again later.');
      } finally {
        setLoading(false);
      }
    }

    fetchContent();
  }, [hash, currentUser]);

  if (loading) {
    return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">Loading...</div>;
  }

  if (error) {
    return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10 text-red-600">{error}</div>;
  }

  if (!content) {
    return <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-10">Content not found</div>;
  }

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-8">
          <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-8">
            <h1 className="text-3xl font-bold mb-6">
              {content.title || 'Processed Content'}
            </h1>
            <div className="prose dark:prose-invert max-w-none">
              <div dangerouslySetInnerHTML={{ __html: content.htmlContent }} />
            </div>
            {currentUser && currentUser.uid === content.userId && (
              <div className="mt-4 text-sm text-gray-500">
                <p>Visibility: {content.isPublic ? 'Public' : 'Private'}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProcessedContent; 